import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

// Flower (the celery background-jobs dashboard) lives on convovec-core, but where it
// sits depends on the environment, so derive it from window.env.API_URL:
//  - deployed: the k8s ingress serves flower under /flower on the API origin
//    (flower runs with --url_prefix=flower) → <api-origin>/flower/workers.
//  - local dev: docker-compose runs flower as its own container on :5555 with no
//    url-prefix (the :3051 app doesn't proxy it) → <host>:5555/workers.
const getFlowerUrl = () => {
  try {
    const api = new URL(globalThis.env.API_URL);
    const isLocal = api.hostname === "localhost" || api.hostname === "127.0.0.1";
    return isLocal ? `${api.protocol}//${api.hostname}:5555/workers` : `${api.origin}/flower/workers`;
  } catch {
    return "/flower/workers";
  }
};

const BackgroundJobsPage = () => {
  useEffect(() => {
    window.open(getFlowerUrl(), "_blank", "noopener,noreferrer");
  }, []);

  return <Navigate to="/scripts" />;
};

export default BackgroundJobsPage;
